import { render } from "./Confirm.vue?vue&type=template&id=8abd102a&scoped=true"
import script from "./Confirm.vue?vue&type=script&lang=ts"
export * from "./Confirm.vue?vue&type=script&lang=ts"

import "./Confirm.vue?vue&type=style&index=0&id=8abd102a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8abd102a"

export default script